
import axiosPost from "../axiosPost";

export const usuarioLugarHorarioDel = async ({
    gateUsuarioLugarHorarioId,
    gateUsuarioLugarHorarioVersion,
}, credentials) => {
    const body = {
        service: "GateUsuarioLugarHorarioDel",
        params: {
            gateUsuarioLugarHorarioId,
            gateUsuarioLugarHorarioVersion,
        },
    };

    return await axiosPost(body, credentials);
};
